import React, { useState, useEffect, useCallback } from "react";
import { globalVars } from "../global/GlobalVars.js";
import * as language from "./language.js";
import LanguageSelector from "../elements/System/LanguageSelector.jsx";
import Login from "../elements/System/Login.jsx";
import Logout from "../elements/System/Logout.jsx";
import Register from "../elements/System/Register.jsx";
import EditUser from "../elements/System/EditUser.jsx";
import UserManagement from "../elements/System/UserManagement.jsx";
import EmailSettings from "../elements/System/EmailSettings.jsx";
import SmsSettings from "../elements/System/SmsSettings.jsx";
import AnalogIn from "../elements/System/AnalogIn.jsx";
import AnalogOut from "../elements/System/AnalogOut.jsx";
import DigitalIn from "../elements/System/DigitalIn.jsx";
import DigitalOut from "../elements/System/DigitalOut.jsx";
import Label from "../elements/Steuerelemente/Label.jsx";
import Datafield from "../elements/Steuerelemente/Datafield.jsx";
import Image from "../elements/Steuerelemente/Image.jsx";
import IFrame from "../elements/Steuerelemente/IFrame.jsx";
import PdfViewer from "../elements/Steuerelemente/PdfViewer.jsx";
import Button from "../elements/Steuerelemente/Button.jsx";
import ToggleButton from "../elements/Steuerelemente/ToggleButton.jsx";
import ButtonReset from "../elements/Steuerelemente/ButtonReset.jsx";
import Link from "../elements/Steuerelemente/Link.jsx";
import LinkTransparent from "../elements/Steuerelemente/LinkTransparent.jsx";
import LinkPolygon from "../elements/Steuerelemente/LinkPolygon.jsx";
import LinkExtern from "../elements/Steuerelemente/LinkExtern.jsx";
import Checkbox from "../elements/Steuerelemente/Checkbox.jsx";
import Statefield from "../elements/Steuerelemente/Statefield.jsx";
import Watchdogfield from "../elements/Steuerelemente/Watchdogfield.jsx";
import DropdownField from "../elements/Steuerelemente/DropdownField.jsx";
import AttrZeit from "../elements/Steuerelemente/AttrZeit.jsx";
import Rectangle from "../elements/Steuerelemente/Rectangle.jsx";
import RectangleOnOff from "../elements/Steuerelemente/RectangleOnOff.jsx";
import RectangleBlink from "../elements/Geräte/RectangleBlink.jsx";
import Trend from "../elements/System/Trend.jsx";
import Zählerstand from "../elements/System/Zählerstand.jsx";
import Zählerauswertung from "../elements/System/Zählerauswertung.jsx";
import TableComponent from "../elements/System/AlarmTable.jsx";
import TableComponentMobile from "../elements/System/AlarmTableMobile.jsx";
import AlarmConfig from "../elements/System/AlarmConfig.jsx";
import Pumpe from "../elements/Geräte/Pumpe.jsx";
import PumpeHzg from "../elements/Geräte/PumpeHzg.jsx";
import Dosierpumpe from "../elements/Geräte/Dosierpumpe.jsx";
import Gebläse from "../elements/Geräte/Gebläse.jsx";
import Ventilator from "../elements/Geräte/Ventilator.jsx";
import Klappe from "../elements/Geräte/Klappe.jsx";
import Ventil from "../elements/Geräte/Ventil.jsx";
import Stangenfilter from "../elements/Geräte/Stangenfilter.jsx";
import KlappeHorizontal from "../elements/Geräte/KlappeHorizontal.jsx";
import KlappeRinne from "../elements/Geräte/KlappeRinne.jsx";
import Motor from "../elements/Geräte/Motor.jsx";
import Niveau from "../elements/Geräte/Niveau.jsx";
import Wächter from "../elements/Geräte/Wächter.jsx";
import Farbwechsel from "../elements/Geräte/Farbwechsel.jsx";
import FarbwechselPolygon from "../elements/Geräte/FarbwechselPolygon.jsx";
import Bildwechsel from "../elements/Geräte/Bildwechsel.jsx";
import Led from "../elements/Geräte/Led.jsx";
import KlappeRLT from "../elements/Geräte/KlappeRLT.jsx";
import KlappeRLTStellung from "../elements/Geräte/KlappeRLTStellung.jsx";
import Handeingriff from "../elements/Geräte/Handeingriff.jsx";
import Heizkurve from "../elements/Steuerelemente/Heizkurve.jsx";
import RenderCustomElements from "./RenderCustomElements.jsx";
import * as websocket from "./communication.js";

//========================================================================
//========================================================================
//========================================================================
// Funktion, um die in ..px angegebene Größe zu skalieren
const parseCssValue = (value, scaleFactor, offset) => {
  const numericValue = parseFloat(value);
  const scaledValue = numericValue * scaleFactor + (offset || 0);
  return `${scaledValue}px`;
};

//========================================================================
//========================================================================
//========================================================================
// Funktion zum rendern eines Elements
const renderElement = (
  element,
  scaleFactor,
  mapIndex,
  xOffset,
  yOffset,
  interfaceProps,
) => {
  //========================================================================
  // Style übertragen und skalieren
  const style = {
    position: "absolute",
    left: parseCssValue(element.left, scaleFactor, xOffset),
    top: parseCssValue(element.top, scaleFactor, yOffset),
    right: parseCssValue(element.right, scaleFactor),
    bottom: parseCssValue(element.bottom, scaleFactor),
    width: parseCssValue(element.width, scaleFactor),
    height: parseCssValue(element.height, scaleFactor),
    fontSize: parseCssValue(element.textFontSize, scaleFactor),
    borderRadius: parseCssValue(element.borderRadius, scaleFactor),
    borderWidth: parseCssValue(element.borderWidth, scaleFactor),
    color: element.textColor,
    fontWeight: element.fontWeight,
    backgroundColor: element.backgroundColor,
    borderColor: element.borderColor,
    visibility: element.visibility,
    opacity: element.opacity,
    display: "flex",
    borderStyle: element.borderStyle,
    justifyContent: element.textHorizontalAlignment,
    // textAlign: element.textHorizontalAlignment,
    alignItems: element.textVerticalAlignment,
    transform: element.transform,
    writingMode: element.writingMode,
    textOrientation: element.textOrientation,
    tooltip: element.tooltip,
    properties: element.properties,
  };

  if (element.blink) {
    style.opacity = element.blinkOpacity;
  } else {
    style.opacity = element.opacity;
  }

  //========================================================================
  // Beispiele
  /*
  "transform": "scaleY(-1) scaleX(-1) rotate(45deg)",
  
  */

  //========================================================================
  // Eigenschaften übertragen für Custom-Elemente
  const props = {
    variable: "",
    ioVariables: [],
    varReference: "",
    text: [],
    color: "",
    path: "",
    visibility: "visible",
    states: [],
  };

  // Eigenschaft Variable
  // if (element.variable) {
  if ("variable" in element || "referenceIsReference" in element) {
    try {
      if (element.varIsReference) {
        // Variable aus übergebener Referenz
        props.variable = element.variable
          .replace("struct", interfaceProps.varReference)
          .toString();
      } else if (element.referenceIsReference) {
        // Variable aus Referenz aus übergebener Referenz
        // Erstellen einer Kopie des Strings
        const newVarReference =
          element.interfaceProps.passedVarReference.slice(); // .slice() erstellt eine Kopie des Strings

        // Ersetzen von "struct" im neuen String
        const updatedVarReference = newVarReference.replace(
          "struct",
          interfaceProps.varReference,
        );
        element.interfaceProps.varReference = updatedVarReference.slice();
      } else if (element.varIsPassed) {
        // übergebene direkte Variable
        props.variable = interfaceProps[element.variable].toString();
      } else {
        // direkte Variable
        props.variable = element.variable.toString();
      }
    } catch (err) {
      console.log("Error in renderElement: ", err);
    }
  }

  // Eigenschaft IO-Variable
  if (element.ioVariables) {
    try {
      props.ioVariables = element.ioVariables;
    } catch (err) {
      console.log("Error in renderElement: ", err);
    }
  }

  // Eigenschaft Text
  if (element.text || element.referenceTextIsTextArray) {
    try {
      if (Array.isArray(element.text)) {
        // direkter Text
        props.text = element.text;
      } else if (element.textIsTextArray) {
        // Text aus übergebenem Array (mehrere Namen, Phasen Filter, etc...)
        let textArrayIndex;
        try {
          if (element.textArrayIndex === undefined) {
            textArrayIndex = 0;
          } else {
            textArrayIndex = parseInt(element.textArrayIndex);
          }

          props.text = interfaceProps[element.text][textArrayIndex];
        } catch (err) {
          console.log("Error in renderElement: ", err);
        }
      } else {
        // übergebener Text
        props.text = interfaceProps[element.text];
      }
    } catch (err) {
      console.log("Error in renderElement: ", err);
    }
  }

  // Eigenschaft Farbe
  if (element.color) {
    try {
      if (!element.colorIsPassed) {
        // direkte Farbe
        props.color = element.color;
      } else {
        // übergebene Farbe
        props.color = interfaceProps[element.color];
      }
    } catch (err) {
      console.log("Error in renderElement: ", err);
    }
  }

  // Eigenschaft Pfad
  if (element.path) {
    try {
      if (!element.pathIsPassed) {
        // direkter Pfad
        props.path = element.path;
      } else {
        // übergebener Pfad
        props.path = interfaceProps[element.path];
      }
    } catch (err) {
      console.log("Error in renderElement: ", err);
    }
  }

  // Eigenschaft Sichtbarkeit
  if (element.visibility) {
    try {
      if (!element.visibilityIsPassed) {
        // direkte Sichtbarkeit
        props.visibility = element.visibility;
      } else {
        // übergebene Sichtbarkeit
        props.visibility = interfaceProps[element.visibility];
      }
    } catch (err) {
      console.log("Error in renderElement: ", err);
    }
  }

  // Eigenschaft für Statustexte
  if (element.states) {
    try {
      if (!element.stateIsPassed) {
        // direkte Statustexte
        props.states = element.states;
      } else {
        // übergebene Statustexte
        props.states = interfaceProps[element.states];
      }
    } catch (err) {
      console.log("Error in renderElement: ", err);
    }
  }

  // Eigenschaften als Array übergeben (z.B. für Texte in custom-Elementen aus custom-Elementen (Korrektur))
  if (element.passArrayIsPassed) {
    let arrayIndex;
    try {
      if (element.passArrayIndex === undefined) {
        arrayIndex = 0;
      } else {
        arrayIndex = parseInt(element.passArrayIndex);
      }
      element.interfaceProps[element.passArray] =
        interfaceProps[element.passArrayKey][arrayIndex];
    } catch (err) {
      console.log("Error in renderElement: ", err);
    }
  }

  //========================================================================
  // Custom-Elemente und Standard-Elemente rendern
  try {
    if (element.type.includes("custom")) {
      // Custom-Elemente
      return (
        <RenderCustomElements
          type={element.type}
          scaleFactor={scaleFactor}
          mapIndex={mapIndex}
          xOffset={parseFloat(style.left)}
          yOffset={parseFloat(style.top)}
          interfaceProps={element.interfaceProps}
        />
      );
    } else {
      // Standard-Elemente

      //========================================================================
      // Element lesbar
      let authRead;
      if (element.authRead) {
        authRead = globalVars.auth.read[element.authRead];
      } else {
        authRead = true;
      }

      //========================================================================
      // Element beschreibbar
      let authWrite;
      if (element.authWrite) {
        authWrite = globalVars.auth.write[element.authWrite];
      } else {
        authWrite = true;
      }

      // für Datenpunkte anmelden
      const newReqDataValues = globalVars.reqDataValues;

      if ("variable" in element) {
        if (authRead) {
          if (!newReqDataValues.includes(props.variable)) {
            newReqDataValues.push(props.variable);
            globalVars.setReqDataValues(newReqDataValues);
            websocket.registerDataPoints(
              globalVars.ws,
              globalVars.reqDataValues,
              "register",
            );
          }
        }
      }

      //========================================================================
      // verschiedene Elemente rendern
      const render = (authWrite) => {
        switch (element.type) {
          case "LanguageSelector":
            return (
              <LanguageSelector style={style} element={element} props={props} />
            );
          case "Login":
            return <Login style={style} element={element} props={props} />;
          case "Logout":
            return <Logout style={style} element={element} props={props} />;
          case "Register":
            return <Register style={style} element={element} props={props} />;
          case "EditUser":
            return <EditUser style={style} element={element} props={props} />;
          case "UserManagement":
            return (
              <UserManagement style={style} element={element} props={props} />
            );
          case "EmailSettings":
            return (
              <EmailSettings style={style} element={element} props={props} />
            );
          case "SmsSettings":
            return (
              <SmsSettings style={style} element={element} props={props} />
            );
          case "AnalogIn":
            return (
              <AnalogIn
                style={style}
                element={element}
                props={props}
                authWrite={authWrite}
              />
            );
          case "AnalogOut":
            return (
              <AnalogOut
                style={style}
                element={element}
                props={props}
                authWrite={authWrite}
              />
            );
          case "DigitalIn":
            return (
              <DigitalIn
                style={style}
                element={element}
                props={props}
                authWrite={authWrite}
              />
            );
          case "DigitalOut":
            return (
              <DigitalOut
                style={style}
                element={element}
                props={props}
                authWrite={authWrite}
              />
            );
          case "Rectangle":
            return <Rectangle style={style} element={element} props={props} />;
          case "RectangleOnOff":
            return (
              <RectangleOnOff style={style} element={element} props={props} />
            );
          case "RectangleBlink":
            return (
              <RectangleBlink style={style} element={element} props={props} />
            );
          case "Label":
            return <Label style={style} element={element} props={props} />;
          case "Datafield":
            return (
              <Datafield
                style={style}
                element={element}
                props={props}
                authWrite={authWrite}
              />
            );
          case "Image":
            return <Image style={style} element={element} props={props} />;
          case "IFrame":
            return <IFrame style={style} element={element} props={props} />;
          case "PdfViewer":
            return <PdfViewer style={style} element={element} props={props} />;
          case "Button":
            return (
              <Button
                style={style}
                element={element}
                props={props}
                authWrite={authWrite}
              />
            );
          case "ToggleButton":
            return (
              <ToggleButton
                style={style}
                element={element}
                props={props}
                authWrite={authWrite}
              />
            );
          case "ButtonReset":
            return (
              <ButtonReset
                style={style}
                element={element}
                props={props}
                authWrite={authWrite}
              />
            );
          case "Link":
            return (
              <Link
                style={style}
                element={element}
                props={props}
                authWrite={authWrite}
              />
            );
          case "LinkTransparent":
            return (
              <LinkTransparent
                style={style}
                element={element}
                props={props}
                authWrite={authWrite}
              />
            );
          case "LinkPolygon":
            return (
              <LinkPolygon
                style={style}
                element={element}
                props={props}
                authWrite={authWrite}
                scaleFactor={scaleFactor}
              />
            );
          case "LinkExtern":
            return (
              <LinkExtern
                style={style}
                element={element}
                props={props}
                authWrite={authWrite}
              />
            );
          case "Checkbox":
            return (
              <Checkbox
                style={style}
                element={element}
                props={props}
                authWrite={authWrite}
              />
            );
          case "Statefield":
            return <Statefield style={style} element={element} props={props} />;
          case "Watchdogfield":
            return (
              <Watchdogfield style={style} element={element} props={props} />
            );
          case "DropdownField":
            return (
              <DropdownField
                style={style}
                element={element}
                props={props}
                authWrite={authWrite}
              />
            );
          case "AttrZeit":
            return <AttrZeit style={style} element={element} props={props} />;
          case "Trend":
            return <Trend style={style} />;
          case "Zählerstand":
            return <Zählerstand style={style} />;
          case "Zählerauswertung":
            return <Zählerauswertung style={style} />;
          case "Pumpe":
            return <Pumpe style={style} element={element} props={props} />;
          case "PumpeHzg":
            return <PumpeHzg style={style} element={element} props={props} />;
          case "Dosierpumpe":
            return (
              <Dosierpumpe style={style} element={element} props={props} />
            );
          case "Gebläse":
            return <Gebläse style={style} element={element} props={props} />;
          case "Ventilator":
            return <Ventilator style={style} element={element} props={props} />;
          case "Klappe":
            return <Klappe style={style} element={element} props={props} />;
          case "Ventil":
            return <Ventil style={style} element={element} props={props} />;
          case "Stangenfilter":
            return (
              <Stangenfilter style={style} element={element} props={props} />
            );
          case "KlappeHorizontal":
            return (
              <KlappeHorizontal style={style} element={element} props={props} />
            );
          case "Motor":
            return <Motor style={style} element={element} props={props} />;
          case "KlappeRinne":
            return (
              <KlappeRinne style={style} element={element} props={props} />
            );
          case "Niveau":
            return <Niveau style={style} element={element} props={props} />;
          case "Wächter":
            return <Wächter style={style} element={element} props={props} />;
          case "Farbwechsel":
            return (
              <Farbwechsel style={style} element={element} props={props} />
            );
          case "FarbwechselPolygon":
            return (
              <FarbwechselPolygon
                style={style}
                element={element}
                props={props}
                scaleFactor={scaleFactor}
              />
            );
          case "Bildwechsel":
            return (
              <Bildwechsel style={style} element={element} props={props} />
            );
          case "Led":
            return <Led style={style} element={element} props={props} />;
          case "KlappeRLT":
            return <KlappeRLT style={style} element={element} props={props} />;
          case "KlappeRLTStellung":
            return (
              <KlappeRLTStellung
                style={style}
                element={element}
                props={props}
              />
            );
          case "Handeingriff":
            return (
              <Handeingriff style={style} element={element} props={props} />
            );
          case "Heizkurve":
            return <Heizkurve style={style} element={element} props={props} />;

          case "AlarmConfig":
            return <AlarmConfig style={style} scaleFactor={scaleFactor} />;
          case "ActiveAlarmTable":
            return (
              <TableComponent
                style={style}
                scaleFactor={scaleFactor}
                activeAlarms={true}
              />
            );
          case "ArchivedAlarmTable":
            return (
              <TableComponent
                style={style}
                scaleFactor={scaleFactor}
                activeAlarms={false}
              />
            );
          case "ActiveAlarmTableMobile":
            return (
              <TableComponentMobile
                style={style}
                scaleFactor={scaleFactor}
                alarms={globalVars.activeAlarms}
                activeAlarms={true}
              />
            );
          case "ArchivedAlarmTableMobile":
            return (
              <TableComponentMobile
                style={style}
                scaleFactor={scaleFactor}
                alarms={globalVars.archivedAlarms}
                activeAlarms={false}
              />
            );
          case "Dummy":
            return <></>;
          default:
            return null;
        }
      };

      //========================================================================
      // Style für Rechteck für nicht beschreibbare Elemente
      const notAuthedStyle = {
        position: "absolute",
        top: style.top,
        left: style.left,
        bottom: style.bottom,
        right: style.right,
        width: style.width,
        height: style.height,
        backgroundColor: "white",
        opacity: 0.5,
      };

      //========================================================================
      // Elemente rendern, falls für Benutzer vorgegeben
      if (authRead) {
        return (
          <div>
            {render(authWrite)}
            {!authWrite && (
              <div style={notAuthedStyle} element={element} props={props}></div>
            )}
          </div>
        );
      }
    }
  } catch (err) {
    return <div>{language.displayText(["Fehler beim laden!!!", "", ""])}</div>;
  }
};

//========================================================================
// Funktionen exportieren
export { renderElement, parseCssValue };
